import React, { useRef, useEffect } from 'react';
import { Outlet, useNavigate } from "react-router-dom";
import { useStore } from './store';
import Header from './Components/elements/Header';
import Footer from './Components/elements/Footer';

import 'react-datasheet-grid/dist/style.css'
import LoadingOverlay from './Components/elements/LoadingOverlay/LoadingOverlay';
import { requestAndGetLocation } from './Utils/Functions/locationUtils';

const appTitle = "Field Reports";

function App() {
  const navigate = useNavigate();
  const {isAuthed, isOnline, isSubmitting} = useStore();
  const hasRequestedLocationRef = useRef(false);

  useEffect(() => {
    if(!isAuthed) {
      navigate("/auth");
    } 
  }, [isAuthed, isOnline, navigate])

  // Request location permissions when user is authenticated (on app load or if they become authenticated)
  useEffect(() => {
    if (isAuthed && !hasRequestedLocationRef.current) {
      hasRequestedLocationRef.current = true;
      requestAndGetLocation()
        .catch((error) => {
          console.warn("Location request during app initialization:", error.message);
          // Silently fail - we'll request location again at submission time
        });
    }
  }, [isAuthed]);
  return (
    <div className="min-h-screen flex flex-col bg-transparent before:w-full before:h-full before:fixed before:z-[-1] before:opacity-10 before:bg-[url(/public/Titan_Logo_Small.png)] before:bg-contain before:bg-fixed before:bg-no-repeat before:bg-center ">
      {isSubmitting && <LoadingOverlay />}
      <Header appTitle={appTitle} />
      <div className="min-h-[85vh] flex flex-col bg-transparent">
        <Outlet />
      </div>
      <Footer appTitle={appTitle} />
    </div>
  );
}

export default App;


